// extracted by mini-css-extract-plugin
module.exports = {"popover":"style_popover__OYMrr","popoverPositionContainer":"style_popoverPositionContainer__3W9Fy"};